function svgToDataUrl(svg: string): string {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
}

function makeIcon(
  google: any,
  svg: string,
  width: number,
  height: number,
  anchorX: number,
  anchorY: number
): any {
  return {
    url: svgToDataUrl(svg),
    scaledSize: new google.maps.Size(width, height),
    anchor: new google.maps.Point(anchorX, anchorY),
  };
}

/**
 * Top-down GO7 delivery bike — faces "up" (north) and rotates with heading.
 * Brand red #E0001B, white accents, black tires.
 */
export function go7MotorcycleMarkerIcon(google: any, heading = 0, size = 64, moving = true): any {
  const pulseOpacity = moving ? 0.28 : 0.12;
  const rot = ((heading % 360) + 360) % 360;
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 80 80">
      <defs>
        <filter id="go7BikeShadow" x="-40%" y="-40%" width="180%" height="180%">
          <feDropShadow dx="0" dy="2" stdDeviation="2.5" flood-color="#000" flood-opacity="0.4"/>
        </filter>
      </defs>
      <!-- soft presence pulse -->
      <circle cx="40" cy="40" r="34" fill="#E0001B" opacity="${pulseOpacity}"/>
      <ellipse cx="40" cy="68" rx="16" ry="5" fill="rgba(0,0,0,0.22)"/>

      <g transform="rotate(${rot} 40 40)" filter="url(#go7BikeShadow)">
        <!-- rear wheel -->
        <circle cx="40" cy="60" r="9" fill="#1a1a1a" stroke="#fff" stroke-width="2"/>
        <circle cx="40" cy="60" r="3.5" fill="#555"/>

        <!-- front wheel -->
        <circle cx="40" cy="16" r="8" fill="#1a1a1a" stroke="#fff" stroke-width="2"/>
        <circle cx="40" cy="16" r="3" fill="#555"/>

        <!-- chassis / body (top-down) -->
        <path d="M34 22
                 C34 20 36 18 40 18
                 C44 18 46 20 46 22
                 L48 38
                 C49 42 49 48 47 52
                 L46 58
                 L34 58
                 L33 52
                 C31 48 31 42 32 38
                 Z" fill="#E0001B" stroke="#fff" stroke-width="1.8"/>

        <!-- seat -->
        <ellipse cx="40" cy="48" rx="7" ry="9" fill="#111" stroke="#fff" stroke-width="1"/>

        <!-- fuel tank / mid body highlight -->
        <ellipse cx="40" cy="34" rx="5.5" ry="8" fill="#C00017"/>
        <ellipse cx="40" cy="32" rx="3" ry="4" fill="#fff" opacity="0.35"/>

        <!-- handlebars -->
        <path d="M28 22 L52 22" stroke="#111" stroke-width="3.5" stroke-linecap="round"/>
        <path d="M28 22 L52 22" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>
        <circle cx="27" cy="22" r="3" fill="#111" stroke="#fff" stroke-width="1.2"/>
        <circle cx="53" cy="22" r="3" fill="#111" stroke="#fff" stroke-width="1.2"/>

        <!-- headlight / nose -->
        <ellipse cx="40" cy="14" rx="4" ry="3" fill="#FFD54F" stroke="#fff" stroke-width="1"/>

        <!-- delivery box (GO7 cargo) -->
        <rect x="30" y="40" width="20" height="14" rx="2.5" fill="#fff" stroke="#E0001B" stroke-width="1.5"/>
        <text x="40" y="50" text-anchor="middle" font-family="Arial,sans-serif" font-size="7" font-weight="800" fill="#E0001B">GO7</text>

        <!-- direction chevron (helps read heading) -->
        <path d="M40 6 L44 12 L40 11 L36 12 Z" fill="#fff"/>
      </g>
    </svg>`;
  return makeIcon(google, svg, size, size, size / 2, size / 2);
}

export function riderMarkerIcon(google: any, heading = 0, size = 56): any {
  return go7MotorcycleMarkerIcon(google, heading, size, true);
}

export function pickupMarkerIcon(google: any, size = 40): any {
  const h = Math.round(size * 1.4);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${h}" viewBox="0 0 40 56">
      <ellipse cx="20" cy="52" rx="8" ry="3" fill="rgba(0,0,0,0.15)"/>
      <path d="M20 2 C11 2 5 10 5 18 C5 30 20 52 20 52 C20 52 35 30 35 18 C35 10 29 2 20 2Z" fill="#E0001B" stroke="#fff" stroke-width="2"/>
      <circle cx="20" cy="18" r="6" fill="#fff"/>
    </svg>`;
  return makeIcon(google, svg, size, h, size / 2, h);
}

export function deliveryMarkerIcon(google: any, size = 40): any {
  const h = Math.round(size * 1.4);
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${h}" viewBox="0 0 40 56">
      <ellipse cx="20" cy="52" rx="8" ry="3" fill="rgba(0,0,0,0.15)"/>
      <path d="M20 2 C11 2 5 10 5 18 C5 30 20 52 20 52 C20 52 35 30 35 18 C35 10 29 2 20 2Z" fill="#00B277" stroke="#fff" stroke-width="2"/>
      <rect x="14" y="13" width="12" height="10" rx="2" fill="#fff"/>
    </svg>`;
  return makeIcon(google, svg, size, h, size / 2, h);
}

export function jobMarkerIcon(google: any, size = 32): any {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 32 32">
      <circle cx="16" cy="16" r="14" fill="#F59E0B" stroke="#fff" stroke-width="3"/>
      <text x="16" y="21" text-anchor="middle" font-size="14" font-weight="700" fill="#fff">₦</text>
    </svg>`;
  return makeIcon(google, svg, size, size, size / 2, size / 2);
}
